

































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompanyMixin from '@/mixins/CompanyMixin';
import ValuationAnalysis from '@/webreport/components/ValuationAnalysis.vue';

@Component({components: {ValuationAnalysis}})
export default class CardValuationAnalysis extends CompanyMixin {
}
